
import { useToast } from "@/components/ui/use-toast";
import { checkWordsMatch } from "@/utils/gameUtils";
import { useGameHooks } from "@/hooks/useGameHooks";

export const useGameLogic = (gameId: string | null, userId: string | null) => {
  // Use the combined hooks
  const gameHooks = useGameHooks(gameId, userId);

  // Return required values from our hook
  return {
    rounds: gameHooks.rounds,
    currentWord: gameHooks.currentWord,
    setCurrentWord: gameHooks.setCurrentWord,
    isRevealed: gameHooks.isRevealed,
    usedWords: gameHooks.usedWords,
    gameOver: gameHooks.gameOver,
    convergenceRound: gameHooks.convergenceRound,
    loading: gameHooks.loading,
    isSubmitting: gameHooks.isSubmitting,
    isOwner: gameHooks.isOwner,
    botHasChosenWord: gameHooks.botHasChosenWord,
    botIsThinking: gameHooks.botIsThinking,
    shouldAutoFocus: gameHooks.shouldAutoFocus,
    setShouldAutoFocus: gameHooks.setShouldAutoFocus,
    handleSubmitWord: gameHooks.handleSubmitWord,
    handleClearWordError: gameHooks.handleClearWordError,
    checkWordsMatch,
    gameStatus: gameHooks.gameStatus,
    userHasSubmitted: gameHooks.userHasSubmitted,
    wordError: gameHooks.wordError,
    processingComplete: gameHooks.processingComplete
  };
};
